import React, { useState } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import ImageUpload from '../components/ui/ImageUpload';

export default function Reporte() {
  const { usuario } = useAuth();
  const [form, setForm] = useState({ 
    tipoAnimal:'Perro', 
    descripcion:'', 
    ubicacion:'', 
    nombreReportante: usuario ? `${usuario.nombre} ${usuario.apellido}` : '' 
  });
  const [foto, setFoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    if (!form.descripcion.trim() || !form.ubicacion.trim()) {
      toast.error('Completa descripción y ubicación'); return;
    }
    setLoading(true);

    const formData = new FormData();
    Object.keys(form).forEach(key => formData.append(key, form[key]));
    if (foto) formData.append('foto', foto);
    if (usuario) formData.append('usuarioId', usuario._id);

    try {
      await api.post('/reportes', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setEnviado(true);
      toast.success('¡Reporte enviado! El equipo lo revisará pronto 🐾');
    } catch {
      toast.error('Error al enviar reporte');
    } finally { setLoading(false); }
  };

  if (enviado) return (
    <div className="page-wrap fade-up text-center pt-[100px]">
      <div className="card max-w-[500px] mx-auto p-[60px]">
        <div className="text-[80px] mb-6">🐾</div>
        <h2 className="sec-title justify-center text-[32px]">¡Reporte recibido!</h2>
        <p className="text-txm text-base mb-8 leading-relaxed">
          El equipo coordinador ha recibido tu reporte. Gracias por ayudar a un animal en necesidad. 
          Un voluntario se asignará pronto.
        </p>
        <button className="btn btn-v btn-lg" onClick={() => { setEnviado(false); setForm({ tipoAnimal:'Perro', descripcion:'', ubicacion:'', nombreReportante: usuario ? `${usuario.nombre} ${usuario.apellido}` : '' }); setFoto(null); }}>
          Enviar otro reporte
        </button>
      </div>
    </div>
  );

  return (
    <div className="page-wrap fade-up">
      <div className="sec-header">
        <h2 className="sec-title">🚨 Reportar un animal</h2>
        <p className="text-[15px] text-txs font-semibold">Tu ayuda es vital para iniciar un rescate rápido</p>
      </div>

      <div className="grid-2 items-start">
        <div className="card">
          <form onSubmit={submit}>
            <div className="f-row">
              <div className="f-group">
                <label className="f-lbl">Tipo de animal</label>
                <select className="f-inp" name="tipoAnimal" value={form.tipoAnimal} onChange={handle}>
                  <option>Perro</option>
                  <option>Gato</option>
                  <option>Otro</option>
                </select>
              </div>
              <div className="f-group">
                <label className="f-lbl">Tu nombre</label>
                <input className="f-inp" name="nombreReportante" placeholder="Nombre o 'Anónimo'" value={form.nombreReportante} onChange={handle} />
              </div>
            </div>

            <div className="f-group">
              <label className="f-lbl">Ubicación exacta</label>
              <input className="f-inp" name="ubicacion" placeholder="Ej: Edificio 14, frente al estacionamiento A" value={form.ubicacion} onChange={handle} required />
            </div>

            <div className="f-group">
              <label className="f-lbl">Descripción y estado</label>
              <textarea
                className="f-inp min-h-[110px] resize-y" name="descripcion"
                placeholder="Describe al animal: color, tamaño, si tiene heridas, comportamiento..."
                value={form.descripcion} onChange={handle} required
              />
            </div>

            <ImageUpload 
              label="Foto del reporte (Muy importante)" 
              onFileSelect={setFoto} 
              currentImage={null} 
            />

            <div className="mt-6">
              <button className="btn btn-v btn-full btn-lg" type="submit" disabled={loading}>
                {loading ? 'Enviando reporte...' : '🚀 Enviar reporte ahora'}
              </button>
            </div>
          </form>
        </div>

        <div className="card info-box bg-ac border-a">
          <h3 className="font-fraunces text-xl text-a mb-4">¿Qué pasa después?</h3>
          <div className="feed-container gap-3">
            {[
              { num: '1', txt: 'El equipo coordinador recibe tu reporte inmediatamente.' },
              { num: '2', txt: 'Se asigna a voluntarios cercanos para atender el caso.' },
              { num: '3', txt: 'El animal es rescatado, evaluado y atendido médicamente.' },
              { num: '4', txt: 'Si estás logueado, sumas ' },
            ].map(i => (
              <div key={i.num} className="flex gap-3 text-sm text-txm font-semibold">
                <span className="w-6 h-6 rounded-full bg-a text-white flex items-center justify-center text-[11px] shrink-0">{i.num}</span>
                <span>{i.txt}{i.num === '4' && <strong>+20 puntos</strong>} por tu reporte.</span>
              </div>
            ))}
          </div>
          <div className="mt-6 p-4 bg-white rounded-xl text-[13px] font-bold text-a text-center">
             🔒 Reporte 100% confidencial
          </div>
        </div>
      </div>
    </div>
  );
}
